module.exports = __webpack_public_path__ + "img/banner.9ac5f4a8.png";